"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RedirectToFirstMenu", {
  enumerable: true,
  get: function get() {
    return _RedirectToFirstMenu.RedirectToFirstMenu;
  }
});

var _RedirectToFirstMenu = require("./RedirectToFirstMenu.connect");